import { Grid, IconButton, Modal, Typography } from '@mui/material';
import { DataGrid, esES, GridToolbar } from '@mui/x-data-grid';
import RolesGate from '../../../../components/utils-components/permissions/rolesGate';
import { ROLES } from '../../../../components/utils-components/permissions/permissions-map';
import { Edit, PersonRemove } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { sendRequest } from '../../../../services/request';
import { DataGridStyle } from '../../../../styles/DataGridSytle';
import EditarUsuario from './editarUsuario';
import ActionConfirmation from '../../../../components/utils-components/ActionConfirmation/ActionConfirmation';

const ManejoUsuarios = ({ roles, paises, reload, setReload }) => {
    const URL = process.env.REACT_APP_API_URL;

    const [data, setData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [limit, setLimit] = useState(50);
    const [page, setPage] = useState(0);

    const [usuarioSelected, setUsuarioSelected] = useState(null);

    // Condicionales
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState({
        modal: false,
        editar: false,
        eliminar: false,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await sendRequest(
                    'get',
                    `${URL}/usuario/all?page=${page}&limit=${limit}`,
                );
                const dataWithIds = res.data.items.map((item, index) => ({
                    item: index + 1,
                    ...item,
                }));
                setData(dataWithIds);
                setRowCount(res.data.meta.totalItems);
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        fetchData();
    }, [URL, limit, page, reload]);

    const columns = [
        {
            field: 'item',
            headerName: 'Item',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            align: 'center',
            renderCell: ({ row }) => {
                return row.item;
            },
        },
        {
            field: 'codigo',
            headerName: 'Código',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            align: 'center',
            renderCell: ({ row }) => {
                return row.codigo;
            },
        },
        {
            field: 'nombres',
            headerName: 'Nombres',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            renderCell: ({ row }) => {
                return row.nombres;
            },
        },
        {
            field: 'apellidos',
            headerName: 'Apellidos',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            renderCell: ({ row }) => {
                return row.apellidos;
            },
        },
        {
            field: 'rol',
            headerName: 'Rol',
            headerClassName: 'header',
            headerAlign: 'center',
            sortable: false,
            flex: 1,
            renderCell: ({ row }) => {
                return row.rol.nombre;
            },
        },
        {
            field: 'acciones',
            type: 'actions',
            cellClassName: 'actions',
            headerName: 'Acciones',
            headerClassName: 'header',
            flex: 1.8,
            getActions: ({ row }) => {
                return [
                    <RolesGate
                        roles={[
                            ROLES.GERENCIA_EFFECTIVE,
                            ROLES.GERENCIA_WINNER,
                            ROLES.DIRECTOR_OPERATIVO,
                        ]}
                    >
                        <IconButton
                            color="primary"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                            }}
                            onClick={() => handleClickEditar(row)}
                        >
                            <Edit />
                            <Typography>Editar</Typography>
                        </IconButton>
                    </RolesGate>,
                    <RolesGate
                        roles={[
                            ROLES.GERENCIA_EFFECTIVE,
                            ROLES.GERENCIA_WINNER,
                            ROLES.DIRECTOR_OPERATIVO,
                        ]}
                    >
                        <IconButton
                            color="danger"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 0,
                            }}
                            onClick={() => handleClickEliminar(row)}
                        >
                            <PersonRemove />
                            <Typography>Eliminar</Typography>
                        </IconButton>
                    </RolesGate>,
                ];
            },
        },
    ];

    const handleClickEditar = (usuario) => {
        setUsuarioSelected(usuario);
        setOpen({ ...open, modal: true, editar: true });
    };

    const handleClickEliminar = (usuario) => {
        setUsuarioSelected(usuario);
        setOpen({ ...open, modal: true, eliminar: true });
    };

    const handlePaginationChange = (event) => {
        setPage(event.page);
        setLimit(event.pageSize);
    };

    const handleClose = () => {
        setOpen({ modal: false, editar: false, eliminar: false });
    };

    const handleEditar = async (data) => {
        try {
            await sendRequest('patch', `${URL}/usuario/${data.id}`, data);
            setReload(!reload);
            handleClose();
        } catch (error) {
            console.log(error);
        }
    };

    const handleEliminar = async (data) => {
        try {
            await sendRequest('delete', `${URL}/usuario/${data.id}`);
            setReload(!reload);
            handleClose();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <DataGrid
                        localeText={
                            esES.components.MuiDataGrid.defaultProps.localeText
                        }
                        disableColumnSelector
                        disableDensitySelector
                        disableColumnFilter
                        disableColumnMenu
                        loading={loading}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: limit },
                            },
                        }}
                        rows={data ? data : []}
                        columns={columns}
                        paginationMode="server"
                        rowCount={rowCount ? rowCount : 0}
                        onPaginationModelChange={handlePaginationChange}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: false,
                                // Estos dos quitan el export
                                printOptions: { disableToolbarButton: true },
                                csvOptions: { disableToolbarButton: true },
                            },
                        }}
                        sx={[
                            DataGridStyle,
                            {
                                '& .MuiDataGrid-virtualScroller': {
                                    minHeight: '30vh',
                                },
                            },
                        ]}
                    ></DataGrid>
                </Grid>
            </Grid>
            <Modal open={open.modal} handleClose={handleClose}>
                <div>
                    {open.editar && (
                        <EditarUsuario
                            usuario={usuarioSelected}
                            setUsuario={setUsuarioSelected}
                            roles={roles}
                            paises={paises}
                            handleEditar={handleEditar}
                            handleClose={handleClose}
                        />
                    )}
                    {open.eliminar && (
                        <ActionConfirmation
                            data={usuarioSelected}
                            handleClose={handleClose}
                            handleConfirm={handleEliminar}
                            title={`¿Está seguro de eliminar al usuario ${
                                usuarioSelected.nombres
                            } ${usuarioSelected?.apellidos || ''}?`}
                            message={
                                'Esto eliminará el usuario de la base de datos y ya no tendra acceso a la plataforma.'
                            }
                            okButton={'Eliminar'}
                        />
                    )}
                </div>
            </Modal>
        </>
    );
};

export default ManejoUsuarios;
